import PrintContentModal from './PrintContentModal';
export default PrintContentModal;
